<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Receipt From Production Case">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty-material" label-cols-lg="12" label="Qty Material" label-for="input-qty-material" size="sm" :model.sync="model.qtyMaterial"  />
				<app-input-textbox id="fieldset-qty-case" label-cols-lg="12" label="Qty Case" label-for="input-qty-case" size="sm" :model.sync="model.qtyCase"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ReceiptFromProductionCase from '@/models/ReceiptFromProduction/ReceiptFromProductionCase';
import ReceiptFromProductionCaseFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionCaseFilter';

import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
import ReceiptFromProductionFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		controlCardId: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				controlCardId: { required : "Control Card is Required."},
			},
			controlCards : [],
			parts : [],
			isBusy: false,
		}
	},
	methods : {
		getReceiptFromProductionCase : async function(id) {
			this.isBusy = true;
			ReceiptFromProductionCase.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getControlCards();
		//this.getParts();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getReceiptFromProductionCase(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getControlCards();
				this.getParts();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getReceiptFromProductionCase(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
